import VueRecaptcha from 'vue-recaptcha'

export default function (Vue) {
  Vue.component('vue-recaptcha', VueRecaptcha)
}
